import { View } from 'react-native';
const TabsScreen = View;
export default TabsScreen;
//# sourceMappingURL=TabsScreen.js.map